import styled from 'styled-components';
const StyledH1 = styled.h1 `
    position: relative;
    color: ${props => props.theme.primary.base};
    font-family: ${props => props.theme.fontHead};
    font-weight: 600;
    margin-bottom: 15px;
    padding-bottom: 8px;
    font-size: 20px;

    &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 38px;
        height: 3px;
        background-color: ${props => props.theme.headingHighlight};
        border-radius: 2px;
    }

    @media only screen and (min-width: 768px) {
        font-size: 24px;
    }
`;
export default StyledH1;
